export default __webpack_public_path__ + "static/media/text_input_element.cde29004.svg";